"use client"; // Ensures the component runs on the client side

import { useState } from "react";
import { Link } from 'react-router-dom';
import eventImg from '../../assets/images/resources/wooden-bottle-openers.jpg';

export default function EventOne() {
  // State for dynamic content
  const [eventContent] = useState({
    sectionTagline: "Featured Products",
    sectionTitle: "Popular Items for Every Occasion",
    buttonText: "View All Products",
    buttonLink: "/services",
    points: [
      {
        id: 1,
        iconClass: "fas fa-bullhorn",
        title: "Brand Visibility Solutions",
        description:
          "Elevate your brand presence with custom promotional products that leave lasting impressions at trade shows, corporate events, and marketing campaigns.",
        link: "/services",
      },
      {
        id: 2,
        iconClass: "fas fa-gift",
        title: "Corporate Gift Programs",
        description:
          "Build stronger relationships with clients and employees through thoughtfully branded merchandise that shows appreciation and reinforces your company values.",
        link: "/services",
      },
    ],
    eventImage: eventImg,
  });

  return (
    <>
      {/* Event One Start */}
      <section id="th-about" className="event-one">
        <div className="container">
          <div
            className="event-one__inner wow fadeInUp"
            data-wow-delay="300ms"
          >
            <div className="event-one__top">
              <div className="section-title text-left">
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">
                    {eventContent.sectionTagline}
                  </span>
                </div>
                <h2 className="section-title__title">
                  {eventContent.sectionTitle}
                </h2>
              </div>
            </div>

            <ul className="list-unstyled event-one__points">
              {eventContent.points.map((point) => (
                <li key={point.id}>
                  <div className="icon">
                    <i className={point.iconClass}></i>
                  </div>
                  <div className="content">
                    <h4>
                      <Link to={point.link}>{point.title}</Link>
                    </h4>
                    <p>{point.description}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="event-one__img-box">
              <img src={eventContent.eventImage} alt="Event" />
            </div>

            {/* Button moved below image */}
            <div className="event-one__btn-box text-center" style={{ marginTop: '30px' }}>
              <Link to={eventContent.buttonLink} className="event-one__btn thm-btn">
                {eventContent.buttonText}
                <span className="icon-arrow-right"></span>
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Event One End */}
    </>
  );
}
